module.exports = __webpack_public_path__ + "media/soundtrack.af80d7c0.mp3";